import {
  Box,
  Button,
  Image,
  ListItem,
  Stack,
  UnorderedList,
  VStack,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { IMG, Menu } from '../../Content/Content';
import { NavLink, useNavigate } from 'react-router-dom';
import { AiOutlineMenu, AiFillCloseCircle } from 'react-icons/ai';
const Header = () => {
  const navigate = useNavigate();
  const [toggle, setToggle] = useState(false);
function OpenMenu(){
    setToggle(!toggle)
}
  function navigateUrl() {
    navigate('/login');
  }
  return (
    <VStack
      position="absolute"
      top="0"
      left="0"
      right="0"
      height="auto"
      paddingTop="10px"
    >
      <Box w="90%" margin="auto" className="desktop-menu" display="block">
        <Box display="flex" alignItems={'start'} justifyContent="space-between">
          {/* Logo box */}
          <Box className="logo-area">
            <NavLink to="/">
              <Image src={IMG.logo} alt="logo" />
            </NavLink>
          </Box>
          {/* Menu */}
          <Box className="menu-area" display="flex" alignItems="center">
            <UnorderedList
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {Menu.map((item, index) => {
                return (
                  <ListItem
                    key={index}
                    listStyleType={'none'}
                    padding={'12px 15px'}
                    margin={'0 10px'}
                    textTransform="capitalize"
                    className="nav-item"
                  >
                    <NavLink
                      to={item.url}
                      className={({ isActive }) =>
                        isActive ? 'active' : 'inactive'
                      }
                    >
                      {item.name}
                    </NavLink>
                  </ListItem>
                );
              })}
            </UnorderedList>
            <Box className="header-btn" marginLeft="20px">
              <Button type="button" onClick={() => navigateUrl()}>
                {' '}
                Create Account
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* mobile menu */}
      <Stack className="Mobile-menu" display="none">
        <Box display="flex" alignItems={'start'} justifyContent="space-between">
          {/* Logo box */}
          <Box className="logo-area">
            <NavLink to="/">
              <Image src={IMG.logo} alt="logo" />
            </NavLink>
          </Box>
          {/* Menu */}
          <Box className="menu-area" display="flex" alignItems="center">
            <Box className="header-btn" marginLeft="20px">
              <Button type="button" onClick={() => navigateUrl()}>
                {' '}
                Create Account
              </Button>
            </Box>
            <Box>
              <Button type="button" bg="transparent" onClick={OpenMenu}>
                <AiOutlineMenu style={{ fontSize: '20px' }} />
              </Button>
            </Box>
            {toggle ? (
              <Box
                position="absolute"
                top="0"
                left="0"
                bg="#F8BC4E "
                h="100vh"
                display=" flex"
                alignItems="center"
                w="100%"
                zIndex="55"
              >
                <Box w="100%">
                  <Button
                    position="absolute"
                    top="20px"
                    right="20px"
                    type="button"
                    bg="transparent"
                    textColor="white"
                    _hover={{ background: 'transparent' }}
                    onClick={OpenMenu}
                  >
                    <AiFillCloseCircle style={{ fontSize: '25px' }} />
                  </Button>
                  <UnorderedList
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                    w="100%"
                  >
                    {Menu.map((item, index) => {
                      return (
                        <ListItem
                          key={index}
                          listStyleType={'none'}
                          padding={'12px 15px'}
                          margin={'0 10px'}
                          textTransform="capitalize"
                          className="nav-item"
                        >
                          <NavLink
                            to={item.url}
                            className={({ isActive }) =>
                              isActive ? 'active' : 'inactive'
                            }
                          >
                            {item.name}
                          </NavLink>
                        </ListItem>
                      );
                    })}
                  </UnorderedList>
                </Box>
              </Box>
            ) : (
              ''
            )}
          </Box>
        </Box>
      </Stack>
    </VStack>
  );
};

export default Header;
